import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Numbers/NumbersSubNav';

export const NumbersLayout = () => LayoutWithSubNav({ navId });
